



















import { Component, Vue } from 'vue-property-decorator';
import skills from '@/data/skills.json'

@Component({
  components: {
  },
})
export default class Footer extends Vue {
  skills: any = skills
  highlighted_skill: any = { icon: "web", title: "Web Development" }

  cycleSkills() {
    let cnt = 0;
    const skills_cnt = this.skills.length;
    const intervalId = setInterval(() => {
      if(cnt === skills_cnt) {
        cnt = 0
      }
      this.highlighted_skill = this.skills[cnt]
      cnt++
    }, 6000);
  }

  created() {
    this.cycleSkills()
  }
}
